<mat-form-field appearance="outline" class="{{ formFieldClass }}" [ngClass]="{ 'mat-form-field-readonly': readonly }">
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    label | translate
    }}</mat-label>
  <input matInput [formControl]="control" [readonly]="readonly" />

  <mat-error *ngIf="control.invalid && control.touched && required && !readonly">
    {{ requiredLabel | translate }}
  </mat-error>
  <mat-error *ngIf="control.hasError('pattern') && control.touched && !readonly">
    {{ 'invalid-link-format' | translate }}
  </mat-error>
</mat-form-field>